import React from 'react';
import { LoadingStateContextProvider } from './LoadingStateContext';
import { Loader } from '../Loader/Loader';
import useInitialMount from '../../../customHooks/useInitialMount';
import { Container } from './LoadingStateWrapper.styles';

export const LoadingStateWrapper = (props) => {
  const {
    data,
    children,
    isPending = null,
    loadingLabel = 'Loading, please wait...',
    introMessage = null,
    noDataMessage = 'Sorry, No Data To Display',
  } = props;

  const isInitialMount = useInitialMount();

  if (introMessage && isInitialMount && !isPending) {
    return introMessage;
  }

  if ((Array.isArray(data) && data.length === 0) || !data || isPending) {
    return (
      <Loader visible={isPending} label={loadingLabel}>
        <Container>{!isPending && <div>{noDataMessage}</div>}</Container>
      </Loader>
    );
  }

  if (data) {
    return <LoadingStateContextProvider value={data}>{children}</LoadingStateContextProvider>;
  }

  return null;
};
